package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class FrontMatterHandler : MarkdownHandler {
    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.index == 0 && ctx.lines.getOrNull(0) == "---"
    }

    override fun handle(ctx: ParsingContext) {
        val frontMatterLines = ctx.lines.asSequence().drop(1).takeWhile { it != "---" }.toList()
        if (frontMatterLines.isNotEmpty()) {
            ctx.index += frontMatterLines.size + 2
            frontMatterLines.forEach {
                val parts = it.split(": ", limit = 2)
                if (parts.size == 2) {
                    ctx.metadata[parts[0]] = parts[1]
                }
            }
        }
    }
}
